module.exports = require("zlib");


//////////////////
// WEBPACK FOOTER
// external "zlib"
// module id = zlib
// module chunks = 5